import axios from "axios";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 15000,
});

// Attach bearer token if we have one
// Serve como fallback caso o cookie não funcione entre origens.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fc_token");

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export function formatApiError(detail) {
  if (detail == null) {
    return "Erro inesperado. Tente novamente.";
  }

  if (typeof detail === "string") {
    return detail;
  }

  if (Array.isArray(detail)) {
    return detail
      .map((error) =>
        error && typeof error.msg === "string"
          ? error.msg
          : JSON.stringify(error)
      )
      .join(" ");
  }

  if (detail && typeof detail.msg === "string") {
    return detail.msg;
  }

  return String(detail);
}